import {memo, useContext, useState} from 'react';

import styled from 'styled-components';

import {addressKeyFromParts} from '~/shared/utils/address';
import {AddressViewValuesMap, LocationTypes, AddressFinderVariant} from '~/shared/consts/addressConsts';
import _AddressFinder from '~/shared/components/AddressFinder';
import {getLocalizationService} from '~/shared/services/localisationService';

import {
  BlockHeader,
  TitleText,
  BackIcon,
  AddressDropdownButton as BackButton,
  FormContainer,
  FormText,
  ButtonBar,
  AddAddressActionButton,
} from './styled.addressDropdown';
import {AddressDropdownContext} from './context';

const AddressFinder = styled(_AddressFinder)`
  &::after {
    margin: 11px;
  }
`;

const UpsertLocalAddressBlock = ({
  editedAddress,
  onSubmit,
  changeAddress,
  titleText,
  subTitleText,
  onViewChange,
  buttonText,
  locationType = LocationTypes.RESIDENTIAL,
}) => {
  const [address, setAddress] = useState(editedAddress || null);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const {isMaxMobile} = useContext(AddressDropdownContext);

  const {t} = getLocalizationService();

  const handleAddressChange = ({address: newAddress}) => {
    setAddress(newAddress);
    setDisableSubmit(!newAddress);
  };

  const handleAddButtonClick = async () => {
    if (!address) {
      return;
    }

    const fullAddress = {
      locationType,
      addressKey: addressKeyFromParts(address),
      ...address,
    };

    if (onSubmit) {
      await onSubmit(fullAddress);
    }

    changeAddress({address: fullAddress});
  };

  return (
    <>
      <BlockHeader>
        <TitleText>{titleText}</TitleText>
        <BackButton onClick={() => onViewChange(AddressViewValuesMap.MAIN)} aria-label={t('back')}>
          <BackIcon />
        </BackButton>
      </BlockHeader>

      <FormContainer>
        <FormText>{subTitleText}</FormText>
        <AddressFinder
          variant={AddressFinderVariant.PIE}
          disableAutoFocus
          placeholder={t('street_house_number_city')}
          onChange={incAddress => handleAddressChange({address: incAddress})}
          submit={handleAddButtonClick}
          disableSubmit={disableSubmit}
          setDisableSubmit={setDisableSubmit}
          isAddAddressMode
          isMaxMobile={isMaxMobile}
        />
      </FormContainer>

      <ButtonBar center>
        <AddAddressActionButton
          data-test-id="submitNewAddressBtn"
          disabled={disableSubmit}
          onClick={handleAddButtonClick}
        >
          {buttonText}
        </AddAddressActionButton>
      </ButtonBar>
    </>
  );
};

export default memo(UpsertLocalAddressBlock);
